import React from "react";
import { Navbar } from "react-bootstrap";
import Footer from "../Components/Footer";

const CancellationPolicies = () => {
  return (
    <>
      <Navbar />
      <div className="container my-5">
        <h2>Cancellation and Refund Policy</h2>
        <p>Last updated on Mar 3, 2025</p>
        <p>
          No cancellations & Refunds are entertained
        </p>
      </div>
      <Footer />
    </>
  );
};

export default CancellationPolicies;
